import React from 'react';

import SearchIcon from '@mui/icons-material/Search';
import Fab from '@mui/material/Fab';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { useTranslation } from "react-i18next";

const VehicleAccordion = (props) => {

  const [t] = useTranslation('common');

  const mapData = Array.isArray(props.opData) ? props.opData : [];
  const vehicleFeatures = mapData[0] && mapData[0].data && mapData[0].data.features
    ? mapData[0].data.features
    : [];

  return (
    <React.Fragment>
      {mapData.map((e) => (
        <Accordion key={e.groupe}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>{
              props.properties.find((f) => f.groupe == e.groupe) ?
                props.properties.find((f) => f.groupe == e.groupe).nom :
                props.apiPlaceholder
            }</Typography>
          </AccordionSummary>
          <div className="ps-2">
            {/* <Fab variant="extended"
                size="small"
                color="primary"
                aria-label="add"
                onClick={() => props.zoomToLocation(props.properties.find((f) => f.groupe == e.groupe) ?
                  props.properties.find((f) => f.groupe == e.groupe).latlong :
                  [], e.groupe)}
              >
                <SearchIcon />
                {props.properties.find((f) => f.groupe == e.groupe) ?
                  props.properties.find((f) => f.groupe == e.groupe).region :
                  props.apiPlaceholder}
              </Fab> */}
            <h6 className="ps-2 pt-3">{e.vehlen} {t("map.accordion.online")} {e.planned} {t("map.accordion.planned")}</h6>
            {(e.data && Array.isArray(e.data.features) ? e.data.features : vehicleFeatures).map((g) => (
              <h6 style={{ cursor: 'pointer' }} key={g.id} className="text-muted fw-light ps-2"
                onClick={() => {
                  props.zoomToLocation([g.geometry.coordinates[1], g.geometry.coordinates[0]], e.groupe, g.id);
                  props.highlightListClick(g, e.groupe)
                }
                }
              >
                {g.properties.agency} | {g.properties.vehicle_id} {t("map.accordion.route")} {g.properties.route_id}
              </h6>
            ))}
          </div>
        </Accordion>
      ))}
    </React.Fragment>
  );

}

export default VehicleAccordion;